import type { CreateOneWorkflowDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";

export default function useAddWorkflow(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/workflows", {
		invalidate: [
			useInvalidateShop(shopId),
			useInvalidateWorkflowListQuery(shopId),
		],
		mapVariables: (body: CreateOneWorkflowDto) => ({
			params: { path: { shopId } },
			body,
		}),
	});
}
